import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import {
  defValueCentroCusto,
  IDataCentroCustos,
} from "../../types/api/contabilidade/pesquisar-centro-custos";

export default function SelectCentroCusto({
  value,
  onChange,
  required = false,
  error = false,
  disabled = false,
  extraParams = {},
}: SelectSimpleApiQueryProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  const inputLabel = value ? `${value.id} - ${value.nome}` : "";

  return (
    <>
      <TextField
        {...{ required, error }}
        label={`Centro de custo fiscal`}
        variant="outlined"
        fullWidth
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          input: { readOnly: true }
        }}
        value={inputLabel}
        helperText={error ? "Campo obrigatório" : ""}
        disabled={disabled}
        sx={{
          pointerEvents: disabled ? "none" : "auto",
        }}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentSelectGeneric
            {...{ handleClose, extraParams }}
            title="Selecionar centro custo"
            queryPath="/contabilidade/centro-custos/pesquisar-centro-custos"
            getItemKey={(item) => item.id}
            getItemLabel={(item) => `${item.id} - ${item.nome}`}
            defaultValue={value || defValueCentroCusto}
            onChange={(value) => {
              onChange(value as IDataCentroCustos);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectSimpleApiQueryProps {
  value: IDataCentroCustos | null;
  onChange: (arg: IDataCentroCustos | null) => void;
  error?: boolean;
  required?: boolean;
  disabled?: boolean;
  extraParams?: { [key: string]: any };
}
